import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginApi, profileApi } from "./authService";

export const login = createAsyncThunk(
    "auth/login",
    async (data, thunkAPI) => {
        try {
            const res = await loginApi(data);
            //console.log("LOGIN RESPONSE:", res); 
            localStorage.setItem("token", res.token);
            return res;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);


export const fetchProfile = createAsyncThunk(
    "auth/profile",
    async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.token;
            //console.log("AUTH STATE TOKEN:", thunkAPI.getState().auth.token);
            const res = await profileApi(token); 
            return res;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

const authSlice = createSlice({
    name: "auth",
    initialState: {
        user: null,
        token: localStorage.getItem("token") || null,
        loading: false,
        error: null,
    },
    reducers: {
        logout: (state) => {
            state.user = null;
            state.token = null;
            localStorage.removeItem("token");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload.user;
                state.token = action.payload.token;
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || "Login gagal";
            })
            .addCase(fetchProfile.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload.user;
            })
            .addCase(fetchProfile.rejected, (state) => {
                state.loading = false;
                state.user = null;
                state.token = null;
                localStorage.removeItem("token");
            });
            
    },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;